import React, { memo, Suspense } from "react";
import { Skeleton } from "@/components/Skeleton";
import { MKDLOGO } from "@/assets/images";
import { ViewMapType } from "@/components/ViewWrapper";

interface LazyLoadProps {
  children: React.ReactNode;
  counts?: number[];
  count?: number;
  className?: string;
  circle?: boolean;
  brand?: boolean;
  view?: ViewMapType["value"];
}

const LazyLoad = ({
  children,
  counts = [1],
  count = 1,
  // className,
  circle = false,
  brand = false
}: LazyLoadProps) => {
  const childrenArray = React.Children.toArray(children).filter(
    Boolean
  ) as React.ReactElement[];
  const className = childrenArray.filter(Boolean)[0]?.props?.className
    ? childrenArray[0]?.props?.className
    : "";
  // console.log("childrenArray >>", childrenArray);
  // console.log("className >>", className);

  return (
    <Suspense
      fallback={
        brand ? (
          <div className="absolute cursor-pointer w-[167px] top-px left-0 [font-family:'Inter-Bold',Helvetica] font-bold text-blue-600 text-2xl tracking-[0] leading-[normal]">
                ContentGapAI
              </div>
        ) : (
          <Skeleton
            counts={counts}
            count={count}
            className={className}
            circle={circle}
          />
        )
      }
    >
      {children}
    </Suspense>
  );
};

export default memo(LazyLoad);
